import React from 'react';

import { useTestingCoursePlaceholderData } from '@modules/testing/hooks';
import { TestingPlaceholder } from '@modules/testing/moleculas';

import type {
    TestingCoursePlaceholderDataProps,
    TestingCoursePlaceholderPayload,
} from '@modules/testing/helpers';

type TestingCoursePrepareProps = {
    type: TestingCoursePlaceholderDataProps['type'];
} & Omit<TestingCoursePlaceholderPayload, 't'>;

const TestingCoursePrepare = (props: TestingCoursePrepareProps): React.ReactElement | null => {
    const { type, course, test, isActiveTest, onStart } = props;

    const placeholder = useTestingCoursePlaceholderData(type, {
        course,
        test,
        isActiveTest,
        onStart,
    });

    return (
        <TestingPlaceholder
            image={placeholder.image}
            content={placeholder.content}
            actions={placeholder.actions}
        />
    );
};

export { TestingCoursePrepare };
